import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {formatDateTime} from "../../../utils/Formatter";
import {FullImagePreview} from "../../../components/FullImagePreview";

const CameraEventView = ({ eventData }) => {

	const {t}  = useTranslation();
	const [imagePreview, setImagePreview] = useState(null);

    return (
        <>
        {imagePreview && <FullImagePreview src={imagePreview} onClick={e => setImagePreview(null)} />}
        <List className="condensedList">
          <ListItem>
            <ListItemText primary={t('Id')} secondary={eventData.Id} />
          </ListItem>
          <ListItem>
            <ListItemText primary={t('Event date')} secondary={formatDateTime(eventData.EventDate)} />
          </ListItem>
          <ListItem>
            <ListItemText primary={t('Camera')} secondary={eventData.CameraId ? eventData.CameraCode : '-'} />
          </ListItem>
           <ListItem>
                <ListItemText primary={t('GUID')} secondary={eventData.ExternalId} />
           </ListItem>
           <ListItem>
                <ListItemText primary={t('Ocr confidence')} secondary={eventData.OcrConfidence} />
           </ListItem>
           <ListItem>
              {eventData.NumberPlateImageUrl && <img src={eventData.NumberPlateImageUrl} />}
          </ListItem>
           <ListItem>
               <a href="#" onClick={e => setImagePreview(eventData.EventImageUrl)}><img src={eventData.EventImageUrl} className="compressedImg" /></a>
          </ListItem>
        </List>
       </>
    );
}

export default CameraEventView;